import axios from 'axios';
import Swal from 'sweetalert2'

const api = axios.create({
    baseURL: '/api',
});

api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 403 || error.response.status === 401) {
        Swal.fire({
            icon: 'warning',
            title: 'Session Expired!',
            text: 'Please re-login',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false,
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result.isConfirmed) {
                location.reload();
            }
        });
    } else if (error.response.status === 422) {
        return Promise.reject(error);
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'Transaction Failed',
            text: 'Please retry again',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false,
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result.isConfirmed) {
                location.reload();
            }
        });
    }
    return Promise.reject(error);
});


/**
 * Initialize loan application process.
 * @returns {Promise<object>} Response data from the API.
 * @throws {Error} If initialization fails.
 */
export async function apiGetInitialize() {
    try {
        const response = await api.get('/sblaf-init');
        return response.data;
    } catch (error) {
        throw error;
    }
}

/**
 * Fetch loan requirements for a specific application.
 * @param {string} app_id - The ID of the loan application.
 * @returns {Promise<object>} Response data from the API.
 * @throws {Error} If fetching loan requirements fails.
 */
export async function apiGetLoanReq(app_id) {
    try {
        const response = await api.get('/sblaf-loan-req', {
            params: { application_id: app_id },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiUpdateLoanReq(form) {
    try {
        const response = await api.post('/sblaf-update-loan-req', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiUpdateLoanStep(form) {
    try {
        const response = await api.post('/sblaf-update-loan-step', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}


// reference api

export async function apiRefBusinessRegistry() {
    try {
        const response = await api.get('/sblaf-ref-business-registry');
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiRefProvince(code = null) {
    try {
        const response = await api.get('/ref-province', {
            params: { region_code: code },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiRefCity(code = null) {
    try {
        const response = await api.get('/ref-city', {
            params: { province_code: code },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiRefBrgy(code = null) {
    try {
        const response = await api.get('/ref-brgy', {
            params: { city_code: code },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiGetHomeAddress(bor_id) {
    try {
        const response = await api.get('/sblaf-bor-address', {
            params: { borrower_id: bor_id },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function apiGetBusInfo(bor_id, bt_code) {
    try {
        const response = await api.get('/sblaf-bus-info', {
            params: {
                borrower_id: bor_id,
                bt_code: bt_code,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiGetCertainBusInfo(id) {
    try {
        const response = await api.get('/sblaf-certain-bus-info', {
            params: {
                id: id,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiCheckBusinessFT(borrower_name, business_name) {
    try {
        const response = await api.get('/sblaf-check-business-ft', {
            params: {
                borrower_name: borrower_name,
                business_name: business_name,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiDiscontinueRiseUp(application_id) {
    try {
        const response = await api.post('/v2-rise-up-discontinue', {
            application_id: application_id
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiCheckPendingApp(form) {
    try {
        const response = await api.get('/sblaf-check-pending-app', {
            params: {
                borrower_id: form.borrower_id,
                application_id: form.application_id,
                bus_id: form.bus_id,
                business_name: form.business_name,
                bt_code: form.bt_code
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function apiUpdateBusinessLoanReq(form) {
    try {
        const response = await api.post('/sblaf-update-business-info-loan-req', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiPostGadTradeRef(form) {
    try {
        const response = await api.post('/sblaf-post-gad-trade-ref', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiGetTradeData(application_id) {
    try {
        const response = await api.get('/sblaf-get-gad-trade-data', {
            params: {
                application_id: application_id,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiRefPurposeFirmRegistry() {
    try {
        const response = await api.get('/sblaf-ref-purpose-firm-registry');
        return response.data;
    } catch (error) {
        throw error;
    }
}





export async function apiPostFirmLoanClass(form) {
    try {
        const response = await api.post('/sblaf-post-firm-loan-class', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiRefAuthRepRegistry() {
    try {
        const response = await api.get('/sblaf-ref-auth-rep-registry');
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiRefFinInfoRegistry() {
    try {
        const response = await api.get('/sblaf-ref-fin-info-registry');
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiPostFinInfo(form) {
    try {
        const response = await api.post('/sblaf-post-fin-info', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiRefLoanInfoRegistry() {
    try {
        const response = await api.get('/sblaf-ref-loan-info-registry');
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiPostLoanInfo(form) {
    try {
        const response = await api.post('/sblaf-post-loan-info', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiGetLoanInfoRegistry(application_id) {
    try {
        const response = await api.get('/sblaf-get-loan-info-registry', {
            params: {
                application_id: application_id,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}



export async function apiPostLoanProceed(form) {
    try {
        const response = await api.post('/sblaf-post-loan-proceed', form);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function apiCheckBusinessERF(borrower_name, business_name, bcode, application_id) {
    try {
        const response = await api.get('/sblaf-check-business-erf', {
            params: {
                borrower_name: borrower_name,
                business_name: business_name,
                bcode: bcode,
                application_id: application_id
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiGetCarinaLoanble(borrower_name, business_name, application_id) {
    try {
        const response = await api.get('/sblaf-check-loanable-carina', {
            params: {
                borrower_name: borrower_name,
                business_name: business_name,
                application_id: application_id
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function apiRefPermit(program_id) {
    try {
        const response = await api.get('/sblaf-ref-permit', {
            params: {
                program_id: program_id
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
